export default __webpack_public_path__ + "77ed12515a01d7df008322d9313a37dd.svg";